import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { Clock, ArrowRight } from "lucide-react";
import { CATEGORIES } from "@/lib/categories";
import { formatFCFA } from "@/lib/user";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const OPERATEURS = ["Orange Money", "MTN MoMo", "Moov Money", "Wave"];

export const OffreDecouverteBanner = () => {
  const [tarifs, setTarifs] = useState(null);

  useEffect(() => {
    axios.get(`${API}/pricing`).then((r) => setTarifs(r.data)).catch(() => {});
  }, []);

  const prix = (id) => tarifs?.[id]?.base?.decouverte;
  const prixMini = tarifs
    ? Math.min(...Object.keys(CATEGORIES).map((id) => prix(id)).filter(Boolean))
    : null;

  return (
  <section className="py-16 bg-[#FAF8F5]" data-testid="offre-decouverte-banner">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="relative overflow-hidden rounded-3xl bg-[#12100E] px-8 py-12 md:px-14"
      >
        <div
          className="absolute -right-24 -top-24 h-72 w-72 rounded-full blur-[110px]"
          style={{ background: "#D4AF37", opacity: 0.3 }}
        />
        <div className="relative flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/40 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]">
              <Clock size={13} /> Offre découverte
            </span>
            <h2 className="font-heading mt-5 text-2xl font-bold tracking-tight text-white md:text-3xl">
              Essayez FodindinCa dès{" "}
              <span className="text-[#D4AF37]" data-testid="decouverte-prix-mini">
                {prixMini ? formatFCFA(prixMini) : "500 FCFA"}
              </span>
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-stone-300 md:text-base">
              24 heures d'accès complet à la zone de votre choix : annonces, messagerie et contacts.
              Payable en quelques secondes par Mobile Money.
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {OPERATEURS.map((op) => (
                <span
                  key={op}
                  className="rounded-full border border-white/15 px-3 py-1.5 text-xs font-semibold text-stone-200"
                >
                  {op}
                </span>
              ))}
            </div>
          </div>

          <div className="flex w-full flex-col gap-3 lg:w-auto">
            {Object.values(CATEGORIES).map((cat) => (
              <Link
                key={cat.id}
                to={`/abonnement?cat=${cat.id}&periode=decouverte`}
                data-testid={`decouverte-cta-${cat.id}`}
                className="group inline-flex items-center justify-between gap-6 rounded-full px-6 py-3.5 text-sm font-semibold text-white transition-transform hover:translate-x-1"
                style={{ backgroundColor: cat.color }}
              >
                <span>{cat.name} · 24 h</span>
                <span className="inline-flex items-center gap-2 opacity-90" data-testid={`decouverte-prix-${cat.id}`}>
                  {prix(cat.id) ? formatFCFA(prix(cat.id)) : "—"} <ArrowRight size={15} />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </motion.div>
      <p className="mt-4 max-w-xl text-xs text-stone-500">
        Un seul accès à la fois. Vous passez à la semaine ou au mois quand vous voulez.
      </p>
    </div>
  </section>
  );
};
